import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getIsAdmin } from './userHelper';

export const useEditTalentTabs = (initialTab = 'Personal Details') => {
  const [activeTab, setActiveTab] = useState('Personal Details');
  const user = useSelector(state => state.user);
  const isAdminUser = user?.type === 'admin' || getIsAdmin();

  const tabs = useMemo(() => {
    const list = ['Personal Details', 'Vacation Allowance'];
    if (isAdminUser) {
      list.push('Feedbacks', 'Tasks');
      if (user?.role === 'Administrator') list.push('Logs');
    }
    return list;
  }, [isAdminUser, user?.role]);

  useEffect(() => {
    setActiveTab(currentTab => {
      if (tabs.includes(initialTab)) return initialTab;
      if (!tabs.includes(currentTab)) return tabs[0];
      return currentTab;
    });
  }, [initialTab, tabs]);

  return { activeTab, setActiveTab, tabs };
};
